/**
 * /erp/orders — Orders shell (ERP v1.2).
 *
 * Thin Outlet-only shell so the list / "new" / detail pages keep their
 * own headers and breadcrumbs (the detail page shows the order code in
 * the heading). Access gating lives in the parent `/erp` shell, which
 * adds `/erp/orders` to the sales-allowed prefixes.
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/erp/orders")({
  component: OrdersShell,
});

function OrdersShell() {
  return <Outlet />;
}
